module.exports = __webpack_public_path__ + "img/icon_attention2.111477a5.svg";